<template>
  <router-view />
</template>

<script>
export default {
  name: 'AuthMaster',
}
</script>

<style scoped></style>
